/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProjectInfoPage } from './ProjectInfoPage';
import {
    ProjectInfoPageFromJSON,
    ProjectInfoPageFromJSONTyped,
    ProjectInfoPageToJSON,
} from './ProjectInfoPage';

/**
 * 
 * @export
 * @interface GetProjects200Response
 */
export interface GetProjects200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetProjects200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetProjects200Response
     */
    error: string;
    /**
     * 
     * @type {ProjectInfoPage}
     * @memberof GetProjects200Response
     */
    data: ProjectInfoPage;
}

/**
 * Check if a given object implements the GetProjects200Response interface.
 */
export function instanceOfGetProjects200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetProjects200ResponseFromJSON(json: any): GetProjects200Response {
    return GetProjects200ResponseFromJSONTyped(json, false);
}

export function GetProjects200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProjects200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': ProjectInfoPageFromJSON(json['data']),
    };
}

export function GetProjects200ResponseToJSON(value?: GetProjects200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': ProjectInfoPageToJSON(value.data),
    };
}

